import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';
import queryString from '@clearscore-group/lib.helpers.query-string';
import { constants } from '@clearscore-group/lib.redux.market';
var getRegistrationProspectId = function getRegistrationProspectId(state) {
  return resolveProp('router.location.pathname', state).replace(/\/step.+\//, '');
};
var router_getRegistrationProspectId = createSelector(getRegistrationProspectId, function (prospectId) {
  return prospectId;
});
var getRegistrationStep = function getRegistrationStep(state, props) {
  var pathname = resolveProp('location.pathname', props) || resolveProp('router.location.pathname', state) || {};
  var step = pathname.match('/step([1-4])');
  return step ? parseInt(step[1], 10) : undefined;
};
var router_getRegistrationStep = createSelector(getRegistrationStep, function (registrationStep) {
  return registrationStep;
});
var getQueryParams = function getQueryParams(state) {
  return queryString.parse(resolveProp('router.location.search', state)) || {};
};
var router_getQueryParams = createSelector(getQueryParams, function (queryParams) {
  return queryParams;
});
var getErrorName = function getErrorName(state) {
  var error = resolveProp('router.location.pathname', state).match('/error.*/([^/]+)/?$');
  return error ? error[1] : 'generic';
};
var router_getErrorName = createSelector(getErrorName, function (errorName) {
  return errorName;
});
var windowPathname = function windowPathname() {
  return window && window.location ? window.location.pathname : undefined;
};
var currentPath = function currentPath(state) {
  return resolveProp('router.location.pathname', state) || windowPathname();
};
var getCurrentPath = createSelector(currentPath, function (path) {
  return path;
});
var marketRegExCaptureGroup = RegExp("^/(".concat(constants.MARKETS.join('|'), ")(.*)$"), 'gi');
var getMarketInPathName = createSelector(getCurrentPath, function (currentPath) {
  return currentPath && currentPath.match(marketRegExCaptureGroup) ? currentPath.replace(marketRegExCaptureGroup, '$1').toLowerCase() : null;
});
var getLocationState = function getLocationState(state) {
  return resolveProp('router.location.state', state) || {};
};
var getLocationState$1 = createSelector(getLocationState, function (locationState) {
  return locationState;
});
var selectorsImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getRegistrationProspectId: router_getRegistrationProspectId,
  getRegistrationStep: router_getRegistrationStep,
  getQueryParams: router_getQueryParams,
  getErrorName: router_getErrorName,
  getMarketInPathName: getMarketInPathName,
  getCurrentPath: getCurrentPath,
  getLocationState: getLocationState$1
});

// eslint-disable-next-line import/prefer-default-export
var selectors = selectorsImport;
export { selectors };